import { ChangeDetectorRef, Injectable, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';


@Injectable()
@Pipe({
  name: 'translateLabels',
  standalone: true,
  pure: false // required to update the value when the promise is resolved
})
export class TranslateLabelsPipe implements PipeTransform, OnDestroy {
  value: any = '';
  lastInput: any = null;
  onTranslationChange: Subscription | undefined;
  onLangChange: Subscription | undefined;
  onDefaultLangChange: Subscription | undefined;

  constructor(
    private translate: TranslateService,
    private _ref: ChangeDetectorRef
  ) {}

  updateValue(input: any): void {
    if (Array.isArray(input)) {
      // Handle array of objects
      this.value = input.map(item => {
        if (item && typeof item === 'object' && 'label' in item) {
          return {
            ...item,
            label: this.translate.instant(item.label)
          };
        }
        return item;
      });
    } else if (input && typeof input === 'object' && 'label' in input) {
      // Handle single object
      this.value = {
        ...input,
        label: this.translate.instant(input.label)
      };
    } else {
      // Handle primitive values
      this.value = input;
    }
    this._ref.markForCheck();
  }

  transform(input: any): any {
    if (!input) {
      return input;
    }

    // If the input hasn't changed, return the cached value
    if (JSON.stringify(input) === JSON.stringify(this.lastInput)) {
      return this.value;
    }

    // Store the input for future comparison
    this.lastInput = JSON.parse(JSON.stringify(input));

    // Update the value
    this.updateValue(input);

    // Clean up existing subscriptions
    this._dispose();

    // Subscribe to translation changes
    this.onTranslationChange = this.translate.onTranslationChange.subscribe(() => {
      this.updateValue(input);
    });

    // Subscribe to language changes
    this.onLangChange = this.translate.onLangChange.subscribe(() => {
      this.updateValue(input);
    });

    // Subscribe to default language changes
    this.onDefaultLangChange = this.translate.onDefaultLangChange.subscribe(() => {
      this.updateValue(input);
    });

    return this.value;
  }

  private _dispose(): void {
    if (this.onTranslationChange) {
      this.onTranslationChange.unsubscribe();
      this.onTranslationChange = undefined;
    }
    if (this.onLangChange) {
      this.onLangChange.unsubscribe();
      this.onLangChange = undefined;
    }
    if (this.onDefaultLangChange) {
      this.onDefaultLangChange.unsubscribe();
      this.onDefaultLangChange = undefined;
    }
  }

  ngOnDestroy(): void {
    this._dispose();
  }
}